export function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

//capitalize only the first letter of the string.
export function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return null;
}

// Generate uuid or random string
export const generateUuId = (length) => {
  var u = "",
    m = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",
    i = 0,
    rb = (Math.random() * 0xffffffff) | 0;
  while (i++ < length) {
    var c = m[i - 1],
      r = rb & 0xf,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    u += c === "-" || c === "4" ? c : v.toString(16);
    rb = i % 8 === 0 ? (Math.random() * 0xffffffff) | 0 : rb >> 4;
  }
  return u;
};

export const wordWrap = (string, length) => {
  let substr = string.substring(0, length);
  if (typeof string === 'string') {
    if (string.length > length) {
      substr = substr + '...';
    }
    return substr;
  }
  return string;
};
